module.exports = __webpack_public_path__ + "static/media/budweiser_boomerang02.be55cbb0.webm";